import { onlineManager } from '@tanstack/react-query';
import { useSyncExternalStore } from 'react';

const subscribe = (onChange: () => void): (() => void) => onlineManager.subscribe(() => onChange());

const isOnline = (): boolean => onlineManager.isOnline();

export const useIsOnline = (): boolean => useSyncExternalStore(subscribe, isOnline, isOnline);
